var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ScrollAppHeader", { attrs: { "attach-home": _vm.attachHome } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bs-b" },
        [
          !_vm.hideAppHeader
            ? _c("AppHeader", { attrs: { "attach-home": _vm.attachHome } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "sub-header" }, [_vm._t("sub-header")], 2)
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-bar" }, [_vm._t("action-bar")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-body", style: _vm.bodyStyle },
        [
          false ? _c("LoadingBounce") : _vm._e(),
          _vm._v(" "),
          _vm._t("layout-body")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-area" }, [_vm._t("modal-area")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "floating-action-menu" },
        [_vm._t("floating-action-menu")],
        2
      ),
      _vm._v(" "),
      _c("WelcomeMessageModal"),
      _vm._v(" "),
      _c("CardPreview", {
        on: {
          "show-report-content-modal": function($event) {
            _vm.reportContentModalIsShown = true
          }
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-size-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.file_size_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "audio-size-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.audio_size_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-type-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.file_type_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "audio-type-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.audio_type_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-reader-unsupported-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.file_reader_unsupported.message")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-image-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_image_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-audio-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_audio_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-video-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_video_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "only-audio-or-video-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("page_editor.alerts.only_audio_or_video")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "unsupported-video-service-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("page_editor.alerts.unsupported_video_service")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "video-load-failed-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.video_load_failed"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.reportContentModalIsShown
        ? _c("ReportContentFromPreview", {
            on: {
              ok: function($event) {
                return _vm.onContentReportSent()
              },
              cancel: function($event) {
                _vm.reportContentModalIsShown = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AiScoreGuideModal"),
      _vm._v(" "),
      _vm.contentReportSuccessModalIsShown
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal no-header-modal hide-cancel-btn",
              attrs: {
                id: "content-report-success-modal",
                "hide-header": true,
                "ok-title": _vm.$t("common.confirm")
              },
              on: {
                ok: function($event) {
                  _vm.contentReportSuccessModalIsShown = false
                }
              }
            },
            [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("common.modal.content_report_success.message")
                  )
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.countryCodeSettingModalIsShown
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal no-header-modal hide-cancel-btn",
              attrs: {
                id: "is-empty-country-code",
                "hide-header": true,
                "ok-title": _vm.$t("common.confirm")
              },
              on: {
                ok: function($event) {
                  _vm.countryCodeSettingModalIsShown = false
                }
              }
            },
            [
              _c("div", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("common.empty_country_code.text"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "country-code-setting-link",
                    attrs: { href: _vm.countryCodeSettingLink }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("common.empty_country_code.link")) + " >"
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "basic-error-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.basic_error_alert.message")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-area" }, [_vm._t("footer")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24df821a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24df821a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLayout.vue
// module id = gUDR
// module chunks = 1